// extracted by mini-css-extract-plugin
export default {"container":"schedule_container__v3FCS","days":"schedule_days__HTmiK","day":"schedule_day__IIQ2y","name":"schedule_name__x66IT","hours":"schedule_hours__P0+gb"};